export default {
    required: 'Required field.',
    email: 'It is an invalid email.',
    // raceCode: 'Sorry! Your race code is wrong! Try again',
    // nickname: 'Sorry! You have use invalid characters (!#?¿...) Try again!',
    minLength: 'Debe tener al menos {{min}} caracteres.',
    maxLength: 'No debe tener más de {{max}} caracteres.',
    samePasswords: 'Las contraseñas no coinciden.',
    minValue: 'Must be equal or greater than {{value}}.',
    maxValue: 'Must be equal or less than {{value}}.',
    numeric: 'Must be a numeric value.',
    decimal: 'Must be a decimal value.',
    selectOne: 'Choose one of the options'
}




// WEBPACK FOOTER //
// src/lang/locales/en/formValidation.js